<po-page-default p-title="Relatório de Pendências" [p-breadcrumb]="breadcrumb">
  <div class="page-summary">
    <div class="page-summary-icon"><span class="an an-warning"></span></div>
    <div class="page-summary-text">
      <p class="po-font-subtitle">Relatório de Pendências</p>
      <p class="page-summary-hint">
        Gere o Relatório de Pendências baseado nas informações da Receita Federal via Sistema Integra Contador.
      </p>
    </div>
  </div>

  <!-- Configuração -->
  <div class="rpt-section po-mt-3">
    <div class="rpt-section-header">
      <i class="an an-gear"></i>
      <span>Configuração</span>
    </div>
    <div class="rpt-section-body">
      <div class="po-row">
        <app-empresa-combo class="po-lg-4 po-md-6 po-sm-12" name="idEmpresa" [(ngModel)]="idEmpresa"
          label="Empresa" placeholder="Buscar por código ou nome da empresa..."
          help="Digite o código (Domínio) ou o nome da empresa para buscar.">
        </app-empresa-combo>
      </div>
      <div class="rpt-action-row po-mt-3">
        <po-button p-label="Gerar Relatório" (p-click)="gerarRelatorio()" [p-loading]="isLoading"></po-button>
      </div>
    </div>
  </div>

  <!-- Loading -->
  @if (isLoading) {
    <div class="pend-loading po-mt-3">
      <i class="an an-clock po-mr-2"></i> Aguarde. Estamos processando a requisição...
    </div>
  }

  <!-- PDF Viewer -->
  @if (pdfUrl && !isLoading) {
    <div class="rpt-section po-mt-3">
      <div class="rpt-section-header">
        <i class="an an-file-pdf"></i>
        <span>Relatório Gerado</span>
      </div>
      <div class="pdf-container">
        <iframe [src]="pdfUrl" class="pdf-iframe" type="application/pdf" title="Relatório de Pendências em PDF"></iframe>
      </div>
    </div>
  }
</po-page-default>
